export const isGetNotificationsFetching = state => state.notifications.isFetching;

export const isNotificationsError = state => state.notifications.isError;

export const notificationsSelector = state => {
    if (!state || !state.notifications || !state.notifications.data) {
        return [];
    }

    return state.notifications.data;
};

export const notificationsMetaSelector = state => {
    if (!state || !state.notifications || !state.notifications.metadata) {
        return {};
    }

    return state.notifications.metadata;
};

export const unreadNotificationsSelector = state => state.toggleUnreadNotifications;
